import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    if (!window.Lenis || !window.gsap || !window.ScrollTrigger) return

    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
    if (this.reducedMotion) return

    this.lenis = new window.Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      orientation: "vertical",
      smoothWheel: true,
    })

    this.lenis.on("scroll", window.ScrollTrigger.update)
    window.gsap.ticker.lagSmoothing(0)

    this.tickerCallback = (time) => this.lenis.raf(time * 1000)
    window.gsap.ticker.add(this.tickerCallback)
  }

  disconnect() {
    if (this.tickerCallback) {
      window.gsap.ticker.remove(this.tickerCallback)
    }
    if (this.lenis) {
      this.lenis.destroy()
      this.lenis = null
    }
  }
}
